module.exports = __webpack_public_path__ + "static/media/eon-access-logo.3594da97.png";